"use client";

import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { MenuItems, UserMenu } from "./sidebar";
import NotificationBell from "@/components/notification-bell";
import MobileChat from "@/components/mobile-chat";
import { ErrorBoundary } from "@/components/error-boundary";

/** Top bar on phones: menu sheet (same nav as the desktop rail), chat, bell. */
export function MobileSidebar({ role, username, userId }: { role?: string; username?: string; userId?: string }) {
  const [open, setOpen] = useState(false);
  const showChat = !!userId && !!username && role !== "service-tech";

  return (
    <div className="flex w-full items-center gap-1">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon">
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="flex w-72 flex-col p-0">
          <SheetTitle className="flex items-center gap-2.5 px-4 pt-5 pb-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-[#2A98D9] to-[#6452F7] text-[11px] font-bold text-white">
              TSE
            </span>
            <span className="text-muted-foreground text-xs font-normal">Сервисный центр</span>
          </SheetTitle>
          <nav className="flex-1 overflow-y-auto px-2">
            <MenuItems role={role} onNavigate={() => setOpen(false)} />
          </nav>
          <div className="px-2 pb-3">
            <UserMenu username={username} role={role} />
          </div>
        </SheetContent>
      </Sheet>
      <span className="text-sm font-semibold">TSE</span>
      <span className="flex-1" />
      {showChat && (
        <ErrorBoundary>
          <MobileChat currentUser={{ id: userId!, username: username! }} />
        </ErrorBoundary>
      )}
      {userId && <NotificationBell userId={userId} />}
    </div>
  );
}
